<template>
	<div class="pos-rel">
		<audio
			:src="src"
			:type="_getAudMimeType(type)"
			controls
			class="full-width"
			:autoplay="autoplay"
		></audio>
	</div>
</template>

<script>
export default {
	name: "AnalyticsElNewsLink",
	props: ["src", "type", "autoplay"],
	methods: {
		_getAudMimeType(obj) {
			return typeof obj === "object" ? obj.S : "audio/mpeg"
		}
	}
}
</script>
